// @flow

const lightenColor = (color, value) => {
  if (color != null) {
    let lighterColor = color.split(',')

    lighterColor[3] = ` ${value})`

    lighterColor = lighterColor.join(',')

    return lighterColor
  }
  return 'none'
}

export default lightenColor



// WEBPACK FOOTER //
// ./src/helpers/lightenColor.js